import { createContext } from 'react';

const RecepiesAppContext = createContext();

export default RecepiesAppContext;
